import { finiteNumber } from './format';

export function toIstAxisTime(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(date);
  const get = (type) => parts.find((part) => part.type === type)?.value || '';
  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}:${get('second')}`;
}

export function formatIstTimeOnly(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('en-IN', {
    timeZone: 'Asia/Kolkata',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date);
}

export function formatIstFullDateTime(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date);
}

function median(values) {
  if (!values.length) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  const middle = Math.floor(sorted.length / 2);
  return sorted.length % 2 ? sorted[middle] : (sorted[middle - 1] + sorted[middle]) / 2;
}

export function prepareSeries(timestamps, values) {
  if (!timestamps || !timestamps.length) return { x: [], y: [] };
  const parsed = timestamps.map((stamp) => (stamp ? new Date(stamp).getTime() : Number.NaN));
  const deltas = parsed
    .slice(1)
    .map((value, index) => value - parsed[index])
    .filter((value) => Number.isFinite(value) && value > 0);
  const cadence = deltas.length > 0 ? median(deltas) : 9_000;
  const gapThreshold = Math.max(30_000, cadence * 3);
  const x = [];
  const y = [];

  timestamps.forEach((stamp, index) => {
    if (
      index > 0 &&
      Number.isFinite(parsed[index]) &&
      Number.isFinite(parsed[index - 1]) &&
      parsed[index] - parsed[index - 1] > gapThreshold
    ) {
      x.push(null);
      y.push(null);
    }
    x.push(stamp ? toIstAxisTime(stamp) : null);
    y.push(finiteNumber(values ? values[index] : null));
  });
  return { x, y };
}
